import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

import { newRate, newValue } from '@tool/index';

const moLeave = observable({
  type: 'chart', // chart, table
  xData: <any[]>[],
  yData: <any[]>[],
  overview: <any[]>[],
  // tableLeft: <any[]>[],
  // tableRight: <any[]>[],
});

const initLeave = action((res: any) => {
  // console.log('=== 离职率时间趋势 === ', res);
  let xData: any[] = [];
  let yData: any[] = [];
  let overview: any[] = [];
  // let tableLeft: any[] = [];
  // let tableRight: any[] = [];

  res.Data?.map((item: any) => {
    xData.push(item.year);
    yData.push(item.rate);
  });

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      if (child.mark === 'change_rate') {
        text += newRate(child.value);
      } else {
        text += child.value;
      }
    });
    overview.push(text);
  });

  moLeave.xData = xData;
  moLeave.yData = yData;
  moLeave.overview = overview;
  // moLeave.tableLeft = tableLeft;
  // moLeave.tableRight = tableRight;
});

const changeType = action((type: string) => {
  moLeave.type = type;
});

export default moLeave;
export { initLeave, changeType };
